import 'reflect-metadata';
import { arsenal_step, arsenal_step_dto } from '@Api';
import { ArsenalUnitStep, PaintStep, SyncEntityState } from '@Models';
import { injectable } from 'inversify';

@injectable()
export class ArsenalStepMapper {
  public map(item: arsenal_step): ArsenalUnitStep {
    return {
      id: item.id,
      size: item.size,
      step: this.mapStep(item.step),
      state: SyncEntityState.Synced,
    } satisfies ArsenalUnitStep as ArsenalUnitStep;
  }

  public mapDto(item: ArsenalUnitStep): arsenal_step_dto {
    return {
      id: item.id === '' ? null : item.id,
      size: item.size,
      step: item.step,
    } satisfies arsenal_step_dto as arsenal_step_dto;
  }

  mapStep(item: arsenal_step.step): PaintStep {
    switch (item) {
      case arsenal_step.step.ASSEMBLED:
        return PaintStep.Assembled;
      case arsenal_step.step.PRIMED:
        return PaintStep.Primed;
      case arsenal_step.step.BASED:
        return PaintStep.Based;
      case arsenal_step.step.PAINTED:
        return PaintStep.Painted;
      case arsenal_step.step.BOUGHT:
        return PaintStep.Bought;
      case arsenal_step.step.UNASSEMBLED:
        return PaintStep.Unassembled;
    }

    return PaintStep.Project;
  }
}
